/**
 * County GEOIDs for the county dropdowns (tracts, blocks, precincts).
 *
 * Tract.county_fips, Block.geoid_county and Precinct.county_fips hold the
 * 5-digit county GEOID (state + county FIPS, e.g. 48453). County.id is a UUID
 * and County.county_fips is only the 3-digit county part, so the GEOID is
 * state_fips + county_fips.
 */

/** The County fields a GEOID is built from; query `state_fips county_fips`. */
export interface CountyFips {
  state_fips?: string | null;
  county_fips?: string | null;
}

/** The county's 5-digit GEOID, or '' when its FIPS codes are missing. */
export function countyGeoid(c: CountyFips): string {
  const county = (c.county_fips || '').trim();
  if (county.length === 5) return county;
  const state = (c.state_fips || '').trim();
  if (!state || !county) return '';
  return `${state.padStart(2, '0')}${county.padStart(3, '0')}`;
}
